import partialImport from './partialImport'

export const farmSubdivisions = {
  partialImport,
}
